import React, { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { dateFormatter } from 'theme/utils';
import { fetchTransferStatuses } from 'actions/transferStatuses';
import moment from 'moment';

let _content = null;

const DesktopView = (props) => {
  const [orderDate, setOrderDate] = useState();
  const [barcode, setBarcode] = useState();
  const [orderNumber, setOrderNumber] = useState();
  const [packageNumber, setPackageNumber] = useState();
  const [sku, setSku] = useState();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [queryObject, setQueryObject] = useState({});
  const [sortObject, setSortObject] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [packageFilterBarRef, setPackageFilterBarRef] = useState(null);
  const [scrollEvent, setScrollEvent] = useState(null);
  const [rerenderFilter, setRerenderFilter] = useState(false);
  const [last15Days, setLast15Days] = useState();

  const setDebouncedQuery = debounce((value) => setQueryObject(value), 1000);

  useEffect(() => {
    setPackageFilterBarRef(React.createRef());
    setScrollEvent(toggleFilterBarStyle());
  }, []);

  useEffect(() => {
    fetchTransferStatuses();
  }, []);

  const rowSelection = {
    onRowSelection: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  function toggleFilterBarStyle() {
    if (packageFilterBarRef !== null && packageFilterBarRef.current) {
      const packageFilterSticky =
        window.scrollY > packageFilterBarRef.current.offsetTop;
      packageFilterSticky === true
        ? packageFilterBarRef.current.classList.add('sticky-property')
        : packageFilterBarRef.current.classList.remove('sticky-property');
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollEvent);
    return () => {
      window.removeEventListener('scroll', scrollEvent);
    };
  }, []);

  const statusId = () => {
    const { activeStatusId, statuses } = props;

    if (activeStatusId) {
      return activeStatusId;
    }

    const { id = null } = statuses[0] || {};
    if (id !== null) {
      localStorage.setItem('localStatusId', JSON.stringify(id));
      return id;
    } else {
      let localStatus = JSON.parse(localStorage.getItem('localStatusId'));
      return localStatus;
    }
  };

  const filterTable = (id) => {
    const { setActiveStatus } = props;
    setActiveStatus(id);
  };

  function packageCountRenderer(packageList) {
    return packageList && packageList.length;
  }

  const getLast15Days = (checked) => {
    const days = moment().subtract(15, 'days').format('YYYY-MM-DD');

    setLast15Days(checked ? days : undefined);
    setRerenderFilter((prev) => !prev);
  };

  const getSortObject = (sortObject) => setSortObject(sortObject);

  const getEnumValue = () => {
    const { activeStatusId, statuses = [] } = props;
    const status = statuses.find((status) => status.id === activeStatusId);
    return status && status.enum_value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'orderNumber') {
      setOrderNumber(value);
    } else if (name === 'packageNumber') {
      setPackageNumber(value);
    } else if (name === 'firstName') {
      setFirstName(value);
    } else if (name === 'lastName') {
      setLastName(value);
    } else if (name === 'barcode') {
      setBarcode(value);
    } else if (name === 'sku') {
      setSku(value);
    }
    setRerenderFilter(true);
  };

  useEffect(() => {
    if (rerenderFilter) {
      updateQueryObject();
      setRerenderFilter(false);
    }
  }, [rerenderFilter]);

  const updateQueryObject = () => {
    const order__date = orderDate && dateFormatter(orderDate, 'DD/MM/YYYY');

    setDebouncedQuery({
      product__barcode: barcode,
      order__date,
      customer__first_name: firstName,
      customer__last_name: lastName,
      product__sku: sku,
      order_number: orderNumber,
      number: packageNumber,
      modified_date__gte: last15Days,
    });
  };

  const handleOrderDate = (orderDate) => {
    setOrderDate(orderDate);
    setRerenderFilter(true);
  };

  return (
    _content &&
    _content({
      props,
      packageFilterBarRef,
      orderDate,
      barcode,
      orderNumber,
      packageNumber,
      sku,
      firstName,
      lastName,
      queryObject,
      sortObject,
      selectedRowKeys,
      rowSelection,
      last15Days,
      packageCountRenderer,
      statusId,
      filterTable,
      getLast15Days,
      getSortObject,
      getEnumValue,
      handleChange,
      handleOrderDate,
    })
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(DesktopView);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/PackageOrderList/desktopView/index.js